@if (notifications.length) {
  <div class="notifications">
    @for (notification of notifications; track notification) {
      <div class="highlight-card" role="alert">
        <div class="highlight-header">
          <div class="highlight-title">
            <span class="highlight-icon">
              <i class="pi pi-megaphone" aria-hidden="true"></i>
            </span>
            <strong class="highlight-heading">{{ notification.title }}</strong>
          </div>
          <button
            (click)="markAsRead(notification)"
            type="button"
            class="highlight-close"
            aria-label="Close"
          >
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        </div>
        <div
          class="highlight-body"
          [innerHTML]="notification.body | safeHtml"
        ></div>
      </div>
    }
  </div>
}
